// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue'
import type { RouteRecordRaw } from 'vue-router';
import {roterPre} from "@/settings";

const systemFormRouter =
{
  path:  roterPre+`/systemForm`,
  name: 'system',
  meta: {
    icon: 'dashboard',
    title: '设置'
  },

  alwaysShow: true,
  component: Layout,
  children: [
    {
      path: 'Basics/:key?',
      component: () => import('@/views/systemForm/setSystem/index.vue'),
      name: 'Basics',
      meta: { title: '店铺配置', noCache: true }
    },
    {
      path: 'modifyStoreInfo',
      component: () => import('@/views/systemForm/setSystem/modifyStoreInfo.vue'),
      name: 'ModifyStoreInfo',
      meta: { title: ' 店铺信息', noCache: true }
    },
    {
      path: 'systemStore',
      name: 'setting_systemStore',
      meta: {
        title: '提货点设置'
      },
      component: () => import('@/views/setting/systemStore/index.vue')
    },
    {
      path: 'applyMents',
      name: 'ApplyMents',
      meta: {
        title: '申请分账商户'
      },
      component: () => import('@/views/systemForm/applyMents/index.vue')
    },
    {
      path: 'applyList',
      name: 'ApplyList',
      meta: {
        title: '分账商户列表'
      },
      component: () => import('@/views/systemForm/applyMents/list.vue')
    },
    {
      path: 'customer_keyword',
      component: () => import('@/views/system/customer_keyword/index.vue'),
      name: 'CustomerKeyword',
      meta: { title: '自动回复' }
    },
    {
      path: 'openAuth/list',
      component: () => import('@/views/setting/openAuth/list.vue'),
      name: 'OpenList',
      meta: { title: '账户管理'},
    },
    {
      path: 'form_list',
      component: () => import('@/views/systemForm/form/index.vue'),
      name: 'FormList',
      meta: {
        title: '系统表单',
        noCache: true,

      }
    },
    {
      path: 'form_create',
      component: () => import('@/views/systemForm/form/create.vue'),
      name: 'CreateForm',
      meta: {
        title: '添加系统表单',
        noCache: true,
        activeMenu: `/merchant/systemForm/form_list`
      }
    },
    {
      path: 'form_detail/:id?',
      component: () => import('@/views/systemForm/form/details.vue'),
      name: 'FormDetail',
      meta: {
        title: '表单详情',
        noCache: true,
        activeMenu: `/merchant/devise/diy/list`
      }
    },

  ]
}

export default systemFormRouter as RouteRecordRaw